import { Stack, Text, Textarea } from "@chakra-ui/react";
import * as React from "react";

import { Field } from "./field";

interface NoteFieldProps {
  label: React.ReactNode;
  placeholder: string;
  hint: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
}

// The reason a ruling has to come with, and the line under it saying so.
export function NoteField({
  hint,
  label,
  onChange,
  placeholder,
  value,
}: NoteFieldProps) {
  return (
    <Stack gap="1.5">
      <Field label={label} required>
        <Textarea
          autoFocus
          rows={3}
          size="md"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </Field>
      <Text color="fg.muted" fontSize="xs">
        {hint}
      </Text>
    </Stack>
  );
}
